import React from 'react'

interface IStackProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: 'row' | 'column'
  size?: 'small' | 'default' | 'large'
  block?: boolean
  align?: 'start' | 'center' | 'end' | 'stretch'
}

const Stack: React.FC<IStackProps> = ({
  children,
  direction = 'row',
  size = 'default',
  block,
  align = 'start',
  ...rest
}) => (
  <div
    {...rest}
    style={{
      width: block ? '100%' : 'auto',
      ...rest.style,
      alignItems:
        align === 'start' || align === 'end' ? `flex-${align}` : align,
      ...rest.style
    }}
    className={`stack stack-${direction} stack-${direction}-${size} ${rest.className}`}
  >
    {children}
  </div>
)

export default Stack
